import React from "react";
import { Button, Checkbox, MenuItem } from "@material-ui/core";
import { RefreshOutlined as RefreshOutlinedIcon } from '@material-ui/icons';

import {Basis, Days} from "components/EditJob";
import {FilterOption} from "../types";

import {
  PopupContainer,
  PopupTitlesContainer,
  PopupTitle,
  StyledCrossButtonDark,
  PopupSectionContainer,
  MultipleCheckboxesContainer,
  StyledFormControlLabel,
  CheckboxLabel,
  StyledMaterialSelector,
  ResetFiltersButton,
  SubmitButtonContainer
} from "../AvailablePositions.styles";

interface FilterOptionsProps {
  onClose: () => void
  availabilityFilter: FilterOption[]
  onSetAvailabilityFilter: (id: number, checked: boolean) => void
  basisFilter?: FilterOption
  onSetBasisFilter: (id: number) => void
  onFiltersApply: () => void
  onFiltersReset: () => void
}

const FilterOptions = ({
                         availabilityFilter,
                         onSetAvailabilityFilter,
                         onClose,
                         basisFilter,
                         onSetBasisFilter,
                         onFiltersApply,
                         onFiltersReset
}: FilterOptionsProps) => {
  return (
    <PopupContainer>
      <PopupTitlesContainer>
        <PopupTitle>Filters</PopupTitle>
        <StyledCrossButtonDark onClick={onClose}/>
      </PopupTitlesContainer>
      <PopupSectionContainer>
        <div>Which days are you looking to work?</div>
        <MultipleCheckboxesContainer>
          {Days.map(({id, text}) => (
            <StyledFormControlLabel
              key={id}
              className="no-fastclick"
              control={<Checkbox
                name={`days-${id}`}
                checked={availabilityFilter.some((option) => option.id === id)}
                onChange={(event, checked) => onSetAvailabilityFilter(id, checked)}
                icon={<img id="officeCheckmark" className="hidden-icon" alt=""
                           src={"img/checkboxUnchecked.svg"}/>}
                checkedIcon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                  src={"img/checkboxChecked.svg"}/>}
              />} label={<CheckboxLabel>{text}</CheckboxLabel>}/>
          ))}
        </MultipleCheckboxesContainer>
      </PopupSectionContainer>
      <PopupSectionContainer>
        <StyledMaterialSelector
          id="basis"
          value={basisFilter ? basisFilter.id : ''}
          name="basis"
          label="Contract Type"
          onChange={(event) => onSetBasisFilter(event.target.value)}
        >
          {Basis.map(({id, text}) => <MenuItem key={id} value={id}>{text}</MenuItem>)}
        </StyledMaterialSelector>
      </PopupSectionContainer>
      <PopupSectionContainer>
        <ResetFiltersButton
          variant="outlined"
          onClick={onFiltersReset}
          startIcon={<RefreshOutlinedIcon />}
          color="primary"
          size="medium"
          id="reset-button"
        >
          Reset Filters
        </ResetFiltersButton>
      </PopupSectionContainer>
      <SubmitButtonContainer>
        <Button
          variant="contained"
          onClick={onFiltersApply}
          color="primary"
          size="large"
          id="continue-button"
          className="bigButtonInNewStyle"
        >
          Apply
        </Button>
      </SubmitButtonContainer>
    </PopupContainer>
  );
}

export default FilterOptions;
